import { config } from "./config";

export const domainName =
  import.meta.env.VITE_ENV !== "local"
    ? config.DOMAIN_NAME
    : "localhost";
